import { ref } from "vue";
import { defineStore } from "pinia";

export interface Alert {
    message: string;
    type: "success" | "danger";
}

export const useAlertStore = defineStore("alert", () => {
    const alert = ref<Alert | null>(null);

    function success(message: string) {
        this.alert = { message, type: "success" };
    }

    function error(message: string) {
        this.alert = { message, type: "danger" };
    }

    function clear() {
        this.alert = null;
    }

    return { alert, success, error, clear };
});
